

























import { defineComponent, computed, ref, watch } from '@vue/composition-api';
export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const isClearFileHistory = ref(false);
    const methods = {
      onChange(checked: string) {
        isClearFileHistory.value = checked === 'delete';
      },
      submit() {
        context.emit('submit', isClearFileHistory.value);
      },
      cancel() {
        innerShow.value = false;
        context.emit('cancel');
      },
    };
    return {
      innerShow,
      isClearFileHistory,
      ...methods,
    };
  },
});
